import { httpGet, httpPost } from 'core/utils/httpClient';
import {
  SingleFlipRequest,
  SegmentRequest,
  SingleParaphraseRequest,
  DefinitionRequest,
  AltsRequest,
  SegmentResponse,
  SingleParaphraseResponse,
  AltsResponse,
  DefinitionResponse,
  SingleFlipResponse,
  FreezeWordsRequest,
  FreezeWordsResponse,
  languageDetectCall,
  languageDetectResponse,
  languageChangeCall,
  languageChangeResponse,
} from '../models/api';
import IndexDbStore from 'core/utils/indexedDbClient';
import { GenericObject } from 'core/models/platform';
import { IndexedDb } from 'config/constants';
import ParaModel from 'src/paraphraser/handlers/ParaModel';

export const getSingleFlip = (params: SingleFlipRequest): Promise<SingleFlipResponse> => {
  return httpGet('/paraphraser/single-flip', params).then((response) => {
    // We are emptying the walts for the profane words available in the single flip response
    try {
      for (const property in response.walts) {
        let eachWord = property.split('~')[0];
        if (ParaModel.profaneWords[eachWord?.toLowerCase()]) {
          response.walts[property] = [];
        }
      }
    } catch (err) {}
    return response;
  });
};

export const getSegment = (params: SegmentRequest): Promise<SegmentResponse> =>
  httpGet('/paraphraser/segment2', params);

export const getNewSegment = (params: SegmentRequest): Promise<SegmentResponse> =>
  httpGet('paraphraser/segment', params);

export const getParaphrase = (
  params: SingleParaphraseRequest,
  strength: number
): Promise<SingleParaphraseResponse> =>
  httpGet('/paraphraser/single-paraphrase', params, strength + '');

export const getDefinition = async (params: DefinitionRequest): Promise<DefinitionResponse> => {
  return IndexDbStore.getInstance()
    .getFromIndexedDB(params.phrase, IndexedDb.collections.definitions)
    .then(async (def) => {
      if (!def) {
        const definition = await httpGet('/paraphraser/get-definition', params);
        IndexDbStore.getInstance().setToIndexedDB(
          params.phrase,
          definition,
          IndexedDb.collections.definitions
        );
        return definition;
      }

      return def;
    })
    .catch(async () => {
      const definition = await httpGet('/paraphraser/get-definition', params);
      IndexDbStore.getInstance().setToIndexedDB(
        params.phrase,
        definition,
        IndexedDb.collections.definitions
      );
      return definition;
    });
};

export const getAlts = (params: AltsRequest): Promise<AltsResponse> => {
  return httpGet('/paraphraser/get-alts', params).then((response) => {
    // We are emptying the alts for the profane words
    try {
      if (ParaModel.profaneWords[params.phrase.split('|')[0]?.toLowerCase()]) response.alts = [];
    } catch (err) {}
    return response;
  });
};

export const postFreezeWords = (
  freezeWordsRequest: FreezeWordsRequest
): Promise<FreezeWordsResponse> => httpPost('/paraphraser/freeze-words', freezeWordsRequest);

export const languageDetect = (params: languageDetectCall): Promise<languageDetectResponse> =>
  httpGet('/utils/detect-language', params);

export const languageConvert = (params: languageChangeCall): Promise<languageChangeResponse> =>
  httpGet('/utils/translate', params);

export const reportingRequest = (postData: GenericObject): Promise<GenericObject> => {
  return httpPost('/reporting', postData);
};
